import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "vsf-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
    @Input() variant: "primary" | "secondary" | "ghost" = "primary";
    @Input() size: "sm" | "md" | "lg" = "md";
    @Input() type: "button" | "submit" | "reset" = "button";
    @Input() disabled = false;
    @Input() block = false;
    @Input() ariaLabel?: string;
    @Input() routerLink?: string | readonly unknown[];

    get className(): string {
        const sizeClass =
            this.size === "sm"
                ? "text-[14px] px-3 py-2"
                : this.size === "lg"
                  ? "text-[16px] px-6 py-3"
                  : "text-[15px] px-4 py-2.5";
        const variantClass =
            this.variant === "secondary"
                ? "border border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
                : this.variant === "ghost"
                  ? "text-primary-600 hover:text-primary-700"
                  : "btn--primary text-white";
        const classes = [
            "btn",
            sizeClass,
            variantClass,
            this.block ? "w-full" : "",
        ].filter(Boolean);
        return classes.join(" ");
    }

    get isLink(): boolean {
        return this.routerLink !== undefined && this.routerLink !== null;
    }
}
